import { ToolSource } from '../api/lambda/ChatActions';

/**
 * ZAP-2318: maps an AI Analyst tool-call citation's `source` to the in-app
 * route used for the "Open in ZeroedIn" link on a tool-call card. Returns
 * undefined when there's no source, or its type has no linkable route.
 *
 * Routes verified against src/index.tsx:
 *  - dataframe -> analyze/dataframes/view/:frameId   (Permission.ViewDataframe)
 *  - dashboard -> analyze/dashboards/view/:dashboardId (Permission.ViewDashboard)
 *    NOTE: `analyze/dashboards/:dashboardId` (no `/view/`) is the EDIT route,
 *    gated by Permission.EditDashboard — not what a citation link should open.
 *  - table     -> table/view/:tableId                (Permission.ViewTable)
 *  - chart     -> analyze/charts/view/chart/:chartId  (Permission.ViewChart)
 */
export const platformLinkFor = (source?: ToolSource): string | undefined => {
	if (!source) return undefined;

	switch (source.type) {
		case 'dataframe':
			return `/analyze/dataframes/view/${source.id}`;
		case 'dashboard':
			return `/analyze/dashboards/view/${source.id}`;
		case 'table':
			return `/table/view/${source.id}`;
		case 'chart':
			return `/analyze/charts/view/chart/${source.id}`;
		default:
			return undefined;
	}
};
